<template>
  <div id="contenedor-agregar-contrato-asunto">
    <v-card>
      <v-card-title class="secondary--text">
        Agregar asunto
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-2"></v-divider>
      <v-card-text>
        <v-form v-model="formularioValido" ref="registrarContratoAsunto">
          <v-row>
            <custom-autocomplete
              v-model="asunto.idSubTema"
              label="Selecciionar Sub Tema"
              :items="getContratoSubTemas"
              itemText="descripcion"
              itemValue="id"
              clearable
              :rules="[mixReglas.requerido]"
              cols="12"
            >
            </custom-autocomplete>
            <text-field
              v-model="asunto.numero"
              label="Número"
              :rules="[mixReglas.requerido]"
              cols="12"
            >
            </text-field>
            <v-col cols="12">
              <TextArea
                v-model="asunto.descripcion"
                label="Descripción"
                rows="2"
                :rules="[mixReglas.requerido]"
              >
              </TextArea>
            </v-col>
            <v-col cols="12">
              <TextArea
                v-model="asunto.responsables"
                label="Responsables"
                rows="2"
                :rules="[mixReglas.requerido]"
              >
              </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="guardar"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Guardar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_SUB_TEMAS from '@/graphql/querys/administracion/contratos/contrato/subtemas/contratoSubTemas.gql';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import TextField from '@/components/inputs/TextField.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoAsuntos from './mixContratoAsuntos';

export default {
  name: 'AgregarContratoAsunto',
  mixins: [mixContratoAsuntos],
  components: {
    TextArea,
    CustomAutocomplete,
    CustomButton,
    TextField,
  },
  props: {
    idTema: {
      type: String,
      required: true,
    },
    idSubTema: {
      type: String,
      required: true,
    },
  },
  apollo: {
    contratoSubTemas: {
      query: CONTRATO_SUB_TEMAS,
      variables() {
        return {
          idTema: this.idTema,
        };
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      asunto: {
        idSubTema: this.idSubTema,
        numero: null,
        descripcion: null,
        responsables: null,
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgergarAsunto();
      this.$emit('asunto-agregado');
    },
    cerrar() {
      this.$refs.registrarContratoAsunto.reset();
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratoSubTemas() {
      if (!this.contratoSubTemas) return [];
      return this.contratoSubTemas;
    },
  },
};
</script>

<style lang="scss"></style>
